const guideGen2 = [
  "Neuborkia – Starter-Pokémon auswählen",
  "Route 29 – Erstes Pokémon begegnen",
  "Rosalia City – Turm der Weisheit & Rivalenkampf",
  "Viola City – 1. Arena (Flug)",
  "Route 32 & Azuria-Höhle (Bellsprout-Turm)",
  "Unionhöhle – durchqueren",
  "Azalea City – 2. Arena (Käfer)",
  "Team Rocket im Slowpoke-Brunnen besiegen",
  "Steineichen City – Ilex-Wald durchqueren",
  "Dukatia City – Radioturm besuchen",
  "3. Arena (Normal – Whitney)",
  "Nationalpark & Käferturnier (optional)",
  "Eklipse City – 4. Arena (Geist – Morty)",
  "Route 38 & Moomoo-Farm",
  "Oliviana City – Leuchtturm & Ampharos-Quest",
  "See des Zorns – rotes Garados fangen",
  "Team Rocket in Mahagonia City & Unterschlupf",
  "5. Arena (Eis – Prismania)",
  "Route 44 & Eispfad",
  "Blackthorn City – 6. Arena (Drache)",
  "Rückreise nach Neuborkia – Top 4 Vorbereitung",
  "Pokémon-Liga am Indigo Plateau",
  "Nach dem Sieg: Zugang zu Kanto",
  "Reise durch Kanto & 8 weitere Arenen",
  "Duell gegen Rot auf dem Silberberg",
];

export default guideGen2;
